import { AppInsights } from '@/appInsights';
import { CMPApi } from '@/modules/cmp-api';
import { EoiFormView } from '@/modules/typescript-cmpApi-client/models';
import store from '@/store';
import { EventEmitter } from 'events';
import { orderBy } from 'lodash';
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import EoiWording from '../../assets/config/eoi-wording.json';
@Options({
  props: {
    eoi: {}
  },
  emits: ['update:eoi']
})
export default class Preferences extends Vue {
  eoi!: EoiFormView;

  @Inject({ from: 'apiService', default: new CMPApi() })
  private apiService!: CMPApi;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private ai = new AppInsights;

  private emailPreferencesList: any = [];
  private areaOfInterestsList: any = [];
  private lawId = '';

  get pageHeader(): string {
    return EoiWording[0].preferences.pageHeader
  }

  get pageBody(): string {
    return EoiWording[0].preferences.pageBody
  }

  mounted() {
    this.eventCtrl.emit('isLoadingData', true);
    this.eventCtrl.emit('canSubmit', true);
    this.GetLawId();
  }

  private GetLawId() {
    const memberDetail = store.getters.getMyMemberDetails;

    if (memberDetail == null) {
      this.apiService.memberApi?.apiV1MemberGetMyMemberDetailGet()
        .then((res: any) => {
          store.dispatch('setMyMemberDetails', res.data.data);
          const personalDetail = res.data.data.personalDetail;
          this.lawId = personalDetail.lawId;
          this.GetAreaOfInterests();
          this.GetEmailPreferences();

        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting My Member Details: ' + err.response.status);
          this.ai.trackException('Error getting details info: ' + err);
          this.eventCtrl.emit('isLoadingData', false);
        })

    } else {
      // already in cache.
      this.lawId = memberDetail.personalDetail.lawId;
      this.GetAreaOfInterests();
      this.GetEmailPreferences();
    }

  }

  private GetAreaOfInterests() {
    this.areaOfInterestsList = store.getters.getAreaOfInterests;

    if (this.areaOfInterestsList == null) {
      this.apiService.memberApi?.apiV1GetIndividualAreasOfInterestLawIdGet(this.lawId)
        .then((res: any) => {
          this.areaOfInterestsList = res.data.data;      
          store.dispatch('setAreaOfInterests', this.areaOfInterestsList);
          this.eoi.aoiList = this.areaOfInterestsList;
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Areas of Interests: ' + err.response.status);
          this.ai.trackException('Error getting Areas of Interests: ' + err);
        })
    }
  }

  private GetEmailPreferences() {
    this.emailPreferencesList = store.getters.getEmailPreferences;

    if (this.emailPreferencesList == null) {
      this.apiService.memberApi?.apiV1GetIndividualEmailPreferencesLawIdGet(this.lawId)
        .then((res: any) => {
          this.emailPreferencesList = res.data.data;
          store.dispatch('setEmailPreferences', this.emailPreferencesList);          
          this.eventCtrl.emit('isLoadingData', false);
          this.eoi.epList = this.emailPreferencesList;
        })
        .catch((err: any) => {
          console.log(err);
          this.eventCtrl.emit('show-snackbar', 'error', 'Error getting Email Preferences: ' + err.response.status);
          this.ai.trackException('Error getting Email Preferences: ' + err);          
          this.eventCtrl.emit('isLoadingData', false);
        })
    }
    else {      
      this.eventCtrl.emit('isLoadingData', false);
    }
  }
}
